module.exports = Jsw.skinUrl + "/icons/16/plesk/file-folder.png?377a0415c8e86b629f04f2de969b6dc7";